import { CompanyListTop } from "@/features/company/components/CompanyListTop";
import { CompanyTable } from "@/features/company/components/CompanyTable";
import { ECompanyContractStatus } from "@/types/enum";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

type TTrialCompanyListPageProps = {};

const contractStatuses = [ECompanyContractStatus.TRIAL];

export const TrialCompanyListPage: FC<TTrialCompanyListPageProps> = () => {
  return (
    <Box>
      <Stack gap={3}>
        <CompanyListTop contractStatuses={contractStatuses} />
        <CompanyTable contractStatuses={contractStatuses} />
      </Stack>
    </Box>
  );
};
